
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ResellerHero from './sections/ResellerHero';
import ResellerPricing from './sections/ResellerPricing';
import ResellerPlanBenefits from './sections/ResellerPlanBenefits';
import ResellerCTA from './sections/ResellerCTA';
import { scenarios } from './business-opportunity/data';

const ResellerSaasLanding: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-gray-50 via-white to-gray-50">
      <Header isLoggedIn={false} />
      <main className="flex-grow">
        <ResellerHero />
        <div className="container mx-auto px-4 py-16">
          <div className="grid md:grid-cols-2 gap-8 auto-rows-fr">
            <div>
              <ResellerPricing scenarios={scenarios} />
            </div>
            <div className="flex flex-col h-full">
              <div className="mb-6 rounded-2xl overflow-hidden">
                <img 
                  src="/lovable-uploads/929fa465-2f7e-4479-95a1-be305ed68eb2.png" 
                  alt="Introductory Offer Discount Coupon" 
                  className="w-full h-auto"
                />
              </div>
              <ResellerPlanBenefits />
            </div>
          </div>
        </div>
        <ResellerCTA />
      </main>
      <Footer />
    </div>
  );
};

export default ResellerSaasLanding;
